import React, { useState, useEffect } from "react";
import "./MovieBookingPage.css"; // Importing your new styles
import { useNavigate } from "react-router-dom";  // Use navigate hook instead of the incorrect 'Navigate' component
import Complete from "./complete";  // Ensure the path is correct for the Complete component

const MovieBookingPage = () => {
  // State management
  const [selectedSeats, setSelectedSeats] = useState(
    JSON.parse(localStorage.getItem("selectedSeats")) || []
  );
  const [movieIndex, setMovieIndex] = useState(
    localStorage.getItem("selectedMovieIndex") || 0
  );
  const [ticketPrice, setTicketPrice] = useState(
    parseInt(localStorage.getItem("selectedMoviePrice")) || 10
  );

  // Movie options with titles and prices
  const movieOptions = [
    { title: "Movie1", price: 10 },
    { title: "Movie2", price: 12 },
    { title: "Movie3", price: 8 },
    { title: "Movie4", price: 9 },
  ];

  const totalSeats = 48;  // Total available seats
  const occupiedSeats = [10, 11, 20, 21, 30, 31, 32, 33];  // Preoccupied seats for demo

  // Handle seat click and toggle selection
  const handleSeatClick = (index) => {
    if (occupiedSeats.includes(index)) return;  // Don't allow selecting occupied seats

    const updatedSeats = selectedSeats.includes(index)
      ? selectedSeats.filter((seat) => seat !== index)
      : [...selectedSeats, index]; // Toggle seat selection

    setSelectedSeats(updatedSeats);
    localStorage.setItem("selectedSeats", JSON.stringify(updatedSeats));  // Store selected seats in localStorage
  };

  const navigate = useNavigate();  // Correct hook for navigation
  const handleCompleteClick = () => {
    navigate('/complete');  // Navigate to the '/complete' page
  };

  const handleMovieChange = (event) => {
    const movieIndex = parseInt(event.target.value);  // Update movie based on selected option
    const moviePrice = movieOptions[movieIndex].price;

    setMovieIndex(movieIndex);
    setTicketPrice(moviePrice);

    // Store selected movie in localStorage
    localStorage.setItem("selectedMovieIndex", movieIndex);
    localStorage.setItem("selectedMoviePrice", moviePrice);
  };

  useEffect(() => {
    // Save selected seats to localStorage on change
    localStorage.setItem("selectedSeats", JSON.stringify(selectedSeats));
  }, [selectedSeats]);

  return (
    <div className="movie-booking-page">
      {/* Movie Selector */}
      <div className="movie-container">
        <label htmlFor="movie">Pick a movie:</label>
        <select id="movie" value={movieIndex} onChange={handleMovieChange}>
          {movieOptions.map((movie, index) => (
            <option key={index} value={index}>
              {movie.title} (${movie.price})
            </option>
          ))}
        </select>
      </div>

      {/* Seat Legend */}
      <ul className="showcase">
        <li>
          <div className="seat"></div>
          <small>N/A</small>
        </li>
        <li>
          <div className="seat selected"></div>
          <small>Selected</small>
        </li>
        <li>
          <div className="seat occupied"></div>
          <small>Occupied</small>
        </li>
      </ul>

      {/* Seat Grid */}
      <div className="container">
        <div className="screen"></div>
        <div className="rows">
          {[...Array(totalSeats)].map((_, index) => (
            <div
              key={index}
              className={`seat ${
                selectedSeats.includes(index)
                  ? "selected"
                  : occupiedSeats.includes(index)
                  ? "occupied"
                  : ""
              }`}
              onClick={() => handleSeatClick(index)}  // Handle seat selection
            ></div>
          ))}
        </div>
      </div>

      {/* Price Display */}
      <p className="text">
        You have selected {selectedSeats.length} seats for a total of $
        {selectedSeats.length * ticketPrice}.
      </p>

      {/* Book Ticket Button */}
      <button onClick={handleCompleteClick}>Book Ticket</button>
    </div>
  );
};

export default MovieBookingPage;
